import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { FullPageSpinner } from '@/components/common/FullPageSpinner';

/**
 * Gate for the authenticated shell. Per 08-staff-ux.md §3/§10.1: a full-page spinner is reserved
 * for initial app boot/auth check only — everywhere else uses scoped skeletons.
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'checking') {
    return <FullPageSpinner />;
  }

  if (status === 'unauthenticated') {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
}
